import { productAddToCartButtonPopupStyles as styles } from "@iewccouk/Overrides/Components/ProductAddToCartButton";
import { colorStrings } from "@iewccouk/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.popupWrapper = {
    ...styles.popupWrapper,
    css: css`
        background-color: #fff;
        border: 1px solid #ccc;
        width: 220px;
        position: absolute;
        display: flex;
        flex-direction: column;
        padding: 10px;
        box-shadow: 0 3px 5px 0 rgba(25, 25, 25, 0.2);
        bottom: calc(100% + 10px);
        pointer-events: all;
        word-wrap: break-word;
        white-space: pre-wrap;
        word-break: break-word;

        &::before {
            content: "";
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -10px;
            border: 10px solid transparent;
            border-top-color: #fff;
        }
    `,
};

styles.popupMessageTitle = {
    ...styles.popupMessageTitle,
    size: "12px",
    weight: 700,
    css: css`
        margin-bottom: 5px;
    `,
};

styles.popupMessageText = {
    ...styles.popupMessageText,
    size: "12px",
    weight: 400,
    css: css`
        margin-bottom: 5px;
    `,
};

styles.closeButton = {
    ...styles.closeButton,
    css: css`
        position: absolute;
        top: 0;
        right: 10px;
        cursor: pointer;
        background-color: transparent;
        border: none;
        height: 10px;
        width: 10px;
        min-width: unset;
        min-height: unset;
        max-width: 20px;
        padding: 0;

        &::before {
            position: absolute;
            content: "";
            width: 100%;
            border-top: 1px solid ${getColor(colorStrings.textMain)};
            transform: rotate(45deg) translate(3px, 3px);
        }

        &::after {
            position: absolute;
            content: "";
            width: 100%;
            border-top: 1px solid ${getColor(colorStrings.textMain)};
            transform: rotate(-45deg) translate(-3px, 3px);
        }

        &:hover {
            background-color: transparent;
        }
    `,
};

styles.actionLink = {
    typographyProps: {
        size: "12px",
    },
};
